import { createSelector } from '@ngrx/store';

import { HotelResultsModuleState } from '@hotels/hotel-results/store/state/hotel-results-module.state';
import { HotelResultsUiModuleState } from '@hotels/hotel-results/store/state/hotel-results-ui-module.state';
import { hotelResultsRootSelector } from '@hotels/hotel-results/store/selectors/hotel-results-root.selector';

export const getUIHotelsState = createSelector(
  hotelResultsRootSelector,
  (state: HotelResultsModuleState) => state.ui
);

export const isLoadingHotelMarkers =
  createSelector(getUIHotelsState, (state: HotelResultsUiModuleState) => state.isLoadingHotelMarkers);

export const isLoadingHotelFilters =
  createSelector(getUIHotelsState, (state: HotelResultsUiModuleState) => state.isLoadingHotelFilters);

export const errorInResutls =
  createSelector(getUIHotelsState, (state: HotelResultsUiModuleState) => state.errorInHotels);
